import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AboutSection from "../../component/AboutBody/AboutSection";

import AboutHead from "../../component/AboutHead/AboutHead";

const About = () => {
  let location = useLocation();
  useEffect(() => {
    if (location.hash) {
      let elem = document.getElementById(location.hash.slice(1));
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [location]);
  return (
    <main id="main">
      <AboutHead />
      <AboutSection />
    </main>
  );
};

export default About;
